import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isLogged } from "./Authentication";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {


return !isLogged() ? <Navigate to="/sign-up" /> : <>{children}</>;}
  

export default AuthGuard;